// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/project.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { EnvironmentInitializer } from "./environment_pb.js";
import { PaginationRequest, PaginationResponse } from "./pagination_pb.js";
import { RunnerKind } from "./runner_configuration_pb.js";
import { Subject } from "./identity_pb.js";

/**
 * @generated from enum gitpod.v1.ProjectPhase
 */
export enum ProjectPhase {
  /**
   * @generated from enum value: PROJECT_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The project is active and can be used
   *
   * @generated from enum value: PROJECT_PHASE_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * The project is marked for deletion and prebuilds are being cleaned up
   *
   * @generated from enum value: PROJECT_PHASE_DELETED = 2;
   */
  DELETED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(ProjectPhase)
proto3.util.setEnumType(ProjectPhase, "gitpod.v1.ProjectPhase", [
  { no: 0, name: "PROJECT_PHASE_UNSPECIFIED" },
  { no: 1, name: "PROJECT_PHASE_ACTIVE" },
  { no: 2, name: "PROJECT_PHASE_DELETED" },
]);

/**
 * @generated from enum gitpod.v1.ProjectRole
 */
export enum ProjectRole {
  /**
   * @generated from enum value: PROJECT_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROJECT_ROLE_ADMIN = 1;
   */
  ADMIN = 1,

  /**
   * @generated from enum value: PROJECT_ROLE_USER = 2;
   */
  USER = 2,

  /**
   * @generated from enum value: PROJECT_ROLE_EDITOR = 3;
   */
  EDITOR = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(ProjectRole)
proto3.util.setEnumType(ProjectRole, "gitpod.v1.ProjectRole", [
  { no: 0, name: "PROJECT_ROLE_UNSPECIFIED" },
  { no: 1, name: "PROJECT_ROLE_ADMIN" },
  { no: 2, name: "PROJECT_ROLE_USER" },
  { no: 3, name: "PROJECT_ROLE_EDITOR" },
]);

/**
 * @generated from message gitpod.v1.CreateProjectRequest
 */
export class CreateProjectRequest extends Message<CreateProjectRequest> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * initializer is the content initializer
   *
   * @generated from field: gitpod.v1.EnvironmentInitializer initializer = 2;
   */
  initializer?: EnvironmentInitializer;

  /**
   * devcontainer_file_path is the path to the devcontainer file relative to the repo root
   *
   * @generated from field: string devcontainer_file_path = 4;
   */
  devcontainerFilePath = "";

  /**
   * automations_file_path is the path to the automations file relative to the repo root
   *
   * @generated from field: string automations_file_path = 5;
   */
  automationsFilePath = "";

  /**
   * technical_description is a detailed technical description of the project
   * This field is not returned by default in GetProject or ListProjects responses
   *
   * 8KB max
   *
   * @generated from field: string technical_description = 6;
   */
  technicalDescription = "";

  /**
   * prebuild_configuration defines how prebuilds are created for this project.
   * If not set, prebuilds are disabled for the project.
   *
   * @generated from field: gitpod.v1.ProjectPrebuildConfiguration prebuild_configuration = 7;
   */
  prebuildConfiguration?: ProjectPrebuildConfiguration;

  constructor(data?: PartialMessage<CreateProjectRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateProjectRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "initializer", kind: "message", T: EnvironmentInitializer },
    { no: 4, name: "devcontainer_file_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "automations_file_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "technical_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "prebuild_configuration", kind: "message", T: ProjectPrebuildConfiguration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateProjectRequest {
    return new CreateProjectRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateProjectRequest {
    return new CreateProjectRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateProjectRequest {
    return new CreateProjectRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateProjectRequest | PlainMessage<CreateProjectRequest> | undefined, b: CreateProjectRequest | PlainMessage<CreateProjectRequest> | undefined): boolean {
    return proto3.util.equals(CreateProjectRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateProjectResponse
 */
export class CreateProjectResponse extends Message<CreateProjectResponse> {
  /**
   * @generated from field: gitpod.v1.Project project = 1;
   */
  project?: Project;

  constructor(data?: PartialMessage<CreateProjectResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateProjectResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project", kind: "message", T: Project },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateProjectResponse {
    return new CreateProjectResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateProjectResponse {
    return new CreateProjectResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateProjectResponse {
    return new CreateProjectResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateProjectResponse | PlainMessage<CreateProjectResponse> | undefined, b: CreateProjectResponse | PlainMessage<CreateProjectResponse> | undefined): boolean {
    return proto3.util.equals(CreateProjectResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateProjectsRequest
 */
export class CreateProjectsRequest extends Message<CreateProjectsRequest> {
  /**
   * @generated from field: repeated gitpod.v1.CreateProjectRequest projects = 1;
   */
  projects: CreateProjectRequest[] = [];

  constructor(data?: PartialMessage<CreateProjectsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateProjectsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "projects", kind: "message", T: CreateProjectRequest, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateProjectsRequest {
    return new CreateProjectsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateProjectsRequest {
    return new CreateProjectsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateProjectsRequest {
    return new CreateProjectsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateProjectsRequest | PlainMessage<CreateProjectsRequest> | undefined, b: CreateProjectsRequest | PlainMessage<CreateProjectsRequest> | undefined): boolean {
    return proto3.util.equals(CreateProjectsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateProjectsResponse
 */
export class CreateProjectsResponse extends Message<CreateProjectsResponse> {
  /**
   * created_projects contains the successfully created projects
   *
   * @generated from field: repeated gitpod.v1.Project created_projects = 1;
   */
  createdProjects: Project[] = [];

  /**
   * failed_projects contains details about projects that failed to create
   *
   * @generated from field: repeated gitpod.v1.CreateProjectsResponse.Failure failed_projects = 2;
   */
  failedProjects: CreateProjectsResponse_Failure[] = [];

  constructor(data?: PartialMessage<CreateProjectsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateProjectsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "created_projects", kind: "message", T: Project, repeated: true },
    { no: 2, name: "failed_projects", kind: "message", T: CreateProjectsResponse_Failure, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateProjectsResponse {
    return new CreateProjectsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateProjectsResponse {
    return new CreateProjectsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateProjectsResponse {
    return new CreateProjectsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateProjectsResponse | PlainMessage<CreateProjectsResponse> | undefined, b: CreateProjectsResponse | PlainMessage<CreateProjectsResponse> | undefined): boolean {
    return proto3.util.equals(CreateProjectsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateProjectsResponse.Failure
 */
export class CreateProjectsResponse_Failure extends Message<CreateProjectsResponse_Failure> {
  /**
   * index is the position in the request array (0-based)
   *
   * @generated from field: int32 index = 1;
   */
  index = 0;

  /**
   * name is the project name that failed
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * error describes why the project creation failed
   *
   * @generated from field: string error = 3;
   */
  error = "";

  constructor(data?: PartialMessage<CreateProjectsResponse_Failure>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateProjectsResponse.Failure";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateProjectsResponse_Failure {
    return new CreateProjectsResponse_Failure().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateProjectsResponse_Failure {
    return new CreateProjectsResponse_Failure().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateProjectsResponse_Failure {
    return new CreateProjectsResponse_Failure().fromJsonString(jsonString, options);
  }

  static equals(a: CreateProjectsResponse_Failure | PlainMessage<CreateProjectsResponse_Failure> | undefined, b: CreateProjectsResponse_Failure | PlainMessage<CreateProjectsResponse_Failure> | undefined): boolean {
    return proto3.util.equals(CreateProjectsResponse_Failure, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateProjectsRequest
 */
export class UpdateProjectsRequest extends Message<UpdateProjectsRequest> {
  /**
   * @generated from field: repeated gitpod.v1.UpdateProjectRequest projects = 1;
   */
  projects: UpdateProjectRequest[] = [];

  constructor(data?: PartialMessage<UpdateProjectsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateProjectsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "projects", kind: "message", T: UpdateProjectRequest, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProjectsRequest {
    return new UpdateProjectsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProjectsRequest {
    return new UpdateProjectsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProjectsRequest {
    return new UpdateProjectsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProjectsRequest | PlainMessage<UpdateProjectsRequest> | undefined, b: UpdateProjectsRequest | PlainMessage<UpdateProjectsRequest> | undefined): boolean {
    return proto3.util.equals(UpdateProjectsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateProjectsResponse
 */
export class UpdateProjectsResponse extends Message<UpdateProjectsResponse> {
  /**
   * updated_projects contains the successfully updated projects
   *
   * @generated from field: repeated gitpod.v1.Project updated_projects = 1;
   */
  updatedProjects: Project[] = [];

  /**
   * failed_projects contains details about projects that failed to update
   *
   * @generated from field: repeated gitpod.v1.UpdateProjectsResponse.Failure failed_projects = 2;
   */
  failedProjects: UpdateProjectsResponse_Failure[] = [];

  constructor(data?: PartialMessage<UpdateProjectsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateProjectsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "updated_projects", kind: "message", T: Project, repeated: true },
    { no: 2, name: "failed_projects", kind: "message", T: UpdateProjectsResponse_Failure, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProjectsResponse {
    return new UpdateProjectsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProjectsResponse {
    return new UpdateProjectsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProjectsResponse {
    return new UpdateProjectsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProjectsResponse | PlainMessage<UpdateProjectsResponse> | undefined, b: UpdateProjectsResponse | PlainMessage<UpdateProjectsResponse> | undefined): boolean {
    return proto3.util.equals(UpdateProjectsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateProjectsResponse.Failure
 */
export class UpdateProjectsResponse_Failure extends Message<UpdateProjectsResponse_Failure> {
  /**
   * index is the position in the request array (0-based)
   *
   * @generated from field: int32 index = 1;
   */
  index = 0;

  /**
   * project_id is the project ID that failed
   *
   * @generated from field: string project_id = 2;
   */
  projectId = "";

  /**
   * error describes why the project update failed
   *
   * @generated from field: string error = 3;
   */
  error = "";

  constructor(data?: PartialMessage<UpdateProjectsResponse_Failure>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateProjectsResponse.Failure";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProjectsResponse_Failure {
    return new UpdateProjectsResponse_Failure().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProjectsResponse_Failure {
    return new UpdateProjectsResponse_Failure().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProjectsResponse_Failure {
    return new UpdateProjectsResponse_Failure().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProjectsResponse_Failure | PlainMessage<UpdateProjectsResponse_Failure> | undefined, b: UpdateProjectsResponse_Failure | PlainMessage<UpdateProjectsResponse_Failure> | undefined): boolean {
    return proto3.util.equals(UpdateProjectsResponse_Failure, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteProjectsRequest
 */
export class DeleteProjectsRequest extends Message<DeleteProjectsRequest> {
  /**
   * @generated from field: repeated string project_ids = 1;
   */
  projectIds: string[] = [];

  constructor(data?: PartialMessage<DeleteProjectsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteProjectsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteProjectsRequest {
    return new DeleteProjectsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteProjectsRequest {
    return new DeleteProjectsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteProjectsRequest {
    return new DeleteProjectsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteProjectsRequest | PlainMessage<DeleteProjectsRequest> | undefined, b: DeleteProjectsRequest | PlainMessage<DeleteProjectsRequest> | undefined): boolean {
    return proto3.util.equals(DeleteProjectsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteProjectsResponse
 */
export class DeleteProjectsResponse extends Message<DeleteProjectsResponse> {
  /**
   * deleted_project_ids contains the IDs of successfully deleted projects
   *
   * @generated from field: repeated string deleted_project_ids = 1;
   */
  deletedProjectIds: string[] = [];

  /**
   * failed_projects contains details about projects that failed to delete
   *
   * @generated from field: repeated gitpod.v1.DeleteProjectsResponse.Failure failed_projects = 2;
   */
  failedProjects: DeleteProjectsResponse_Failure[] = [];

  constructor(data?: PartialMessage<DeleteProjectsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteProjectsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "deleted_project_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "failed_projects", kind: "message", T: DeleteProjectsResponse_Failure, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteProjectsResponse {
    return new DeleteProjectsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteProjectsResponse {
    return new DeleteProjectsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteProjectsResponse {
    return new DeleteProjectsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteProjectsResponse | PlainMessage<DeleteProjectsResponse> | undefined, b: DeleteProjectsResponse | PlainMessage<DeleteProjectsResponse> | undefined): boolean {
    return proto3.util.equals(DeleteProjectsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteProjectsResponse.Failure
 */
export class DeleteProjectsResponse_Failure extends Message<DeleteProjectsResponse_Failure> {
  /**
   * index is the position in the request array (0-based)
   *
   * @generated from field: int32 index = 1;
   */
  index = 0;

  /**
   * project_id is the project ID that failed
   *
   * @generated from field: string project_id = 2;
   */
  projectId = "";

  /**
   * error describes why the project deletion failed
   *
   * @generated from field: string error = 3;
   */
  error = "";

  constructor(data?: PartialMessage<DeleteProjectsResponse_Failure>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteProjectsResponse.Failure";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteProjectsResponse_Failure {
    return new DeleteProjectsResponse_Failure().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteProjectsResponse_Failure {
    return new DeleteProjectsResponse_Failure().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteProjectsResponse_Failure {
    return new DeleteProjectsResponse_Failure().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteProjectsResponse_Failure | PlainMessage<DeleteProjectsResponse_Failure> | undefined, b: DeleteProjectsResponse_Failure | PlainMessage<DeleteProjectsResponse_Failure> | undefined): boolean {
    return proto3.util.equals(DeleteProjectsResponse_Failure, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateProjectFromEnvironmentRequest
 */
export class CreateProjectFromEnvironmentRequest extends Message<CreateProjectFromEnvironmentRequest> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * environment_id specifies the environment identifier
   *
   * @generated from field: string environment_id = 2;
   */
  environmentId = "";

  constructor(data?: PartialMessage<CreateProjectFromEnvironmentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateProjectFromEnvironmentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateProjectFromEnvironmentRequest {
    return new CreateProjectFromEnvironmentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateProjectFromEnvironmentRequest {
    return new CreateProjectFromEnvironmentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateProjectFromEnvironmentRequest {
    return new CreateProjectFromEnvironmentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateProjectFromEnvironmentRequest | PlainMessage<CreateProjectFromEnvironmentRequest> | undefined, b: CreateProjectFromEnvironmentRequest | PlainMessage<CreateProjectFromEnvironmentRequest> | undefined): boolean {
    return proto3.util.equals(CreateProjectFromEnvironmentRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateProjectFromEnvironmentResponse
 */
export class CreateProjectFromEnvironmentResponse extends Message<CreateProjectFromEnvironmentResponse> {
  /**
   * @generated from field: gitpod.v1.Project project = 1;
   */
  project?: Project;

  constructor(data?: PartialMessage<CreateProjectFromEnvironmentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateProjectFromEnvironmentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project", kind: "message", T: Project },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateProjectFromEnvironmentResponse {
    return new CreateProjectFromEnvironmentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateProjectFromEnvironmentResponse {
    return new CreateProjectFromEnvironmentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateProjectFromEnvironmentResponse {
    return new CreateProjectFromEnvironmentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateProjectFromEnvironmentResponse | PlainMessage<CreateProjectFromEnvironmentResponse> | undefined, b: CreateProjectFromEnvironmentResponse | PlainMessage<CreateProjectFromEnvironmentResponse> | undefined): boolean {
    return proto3.util.equals(CreateProjectFromEnvironmentResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetProjectRequest
 */
export class GetProjectRequest extends Message<GetProjectRequest> {
  /**
   * project_id specifies the project identifier
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  constructor(data?: PartialMessage<GetProjectRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetProjectRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProjectRequest {
    return new GetProjectRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProjectRequest {
    return new GetProjectRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProjectRequest {
    return new GetProjectRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetProjectRequest | PlainMessage<GetProjectRequest> | undefined, b: GetProjectRequest | PlainMessage<GetProjectRequest> | undefined): boolean {
    return proto3.util.equals(GetProjectRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetProjectResponse
 */
export class GetProjectResponse extends Message<GetProjectResponse> {
  /**
   * @generated from field: gitpod.v1.Project project = 1;
   */
  project?: Project;

  constructor(data?: PartialMessage<GetProjectResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetProjectResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project", kind: "message", T: Project },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProjectResponse {
    return new GetProjectResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProjectResponse {
    return new GetProjectResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProjectResponse {
    return new GetProjectResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetProjectResponse | PlainMessage<GetProjectResponse> | undefined, b: GetProjectResponse | PlainMessage<GetProjectResponse> | undefined): boolean {
    return proto3.util.equals(GetProjectResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateProjectRequest
 */
export class UpdateProjectRequest extends Message<UpdateProjectRequest> {
  /**
   * project_id specifies the project identifier
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * initializer is the content initializer
   *
   * @generated from field: optional gitpod.v1.EnvironmentInitializer initializer = 4;
   */
  initializer?: EnvironmentInitializer;

  /**
   * devcontainer_file_path is the path to the devcontainer file relative to the repo root
   *
   * @generated from field: optional string devcontainer_file_path = 5;
   */
  devcontainerFilePath?: string;

  /**
   * automations_file_path is the path to the automations file relative to the repo root
   *
   * @generated from field: optional string automations_file_path = 6;
   */
  automationsFilePath?: string;

  /**
   * technical_description is a detailed technical description of the project
   * This field is not returned by default in GetProject or ListProjects responses
   *
   * 8KB max
   *
   * @generated from field: optional string technical_description = 7;
   */
  technicalDescription?: string;

  /**
   * prebuild_configuration defines how prebuilds are created for this project.
   * If not provided, the existing prebuild configuration is not modified.
   * To disable prebuilds, set enabled to false.
   *
   * @generated from field: optional gitpod.v1.ProjectPrebuildConfiguration prebuild_configuration = 8;
   */
  prebuildConfiguration?: ProjectPrebuildConfiguration;

  /**
   * recommended_editors specifies the editors recommended for this project.
   * If not provided, the existing recommended editors are not modified.
   * To clear all recommended editors, set to an empty RecommendedEditors message.
   *
   * @generated from field: optional gitpod.v1.RecommendedEditors recommended_editors = 9;
   */
  recommendedEditors?: RecommendedEditors;

  constructor(data?: PartialMessage<UpdateProjectRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateProjectRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "initializer", kind: "message", T: EnvironmentInitializer, opt: true },
    { no: 5, name: "devcontainer_file_path", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "automations_file_path", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "technical_description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "prebuild_configuration", kind: "message", T: ProjectPrebuildConfiguration, opt: true },
    { no: 9, name: "recommended_editors", kind: "message", T: RecommendedEditors, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProjectRequest {
    return new UpdateProjectRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProjectRequest {
    return new UpdateProjectRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProjectRequest {
    return new UpdateProjectRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProjectRequest | PlainMessage<UpdateProjectRequest> | undefined, b: UpdateProjectRequest | PlainMessage<UpdateProjectRequest> | undefined): boolean {
    return proto3.util.equals(UpdateProjectRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateProjectResponse
 */
export class UpdateProjectResponse extends Message<UpdateProjectResponse> {
  /**
   * @generated from field: gitpod.v1.Project project = 1;
   */
  project?: Project;

  constructor(data?: PartialMessage<UpdateProjectResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateProjectResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project", kind: "message", T: Project },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProjectResponse {
    return new UpdateProjectResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProjectResponse {
    return new UpdateProjectResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProjectResponse {
    return new UpdateProjectResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProjectResponse | PlainMessage<UpdateProjectResponse> | undefined, b: UpdateProjectResponse | PlainMessage<UpdateProjectResponse> | undefined): boolean {
    return proto3.util.equals(UpdateProjectResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListProjectsRequest
 */
export class ListProjectsRequest extends Message<ListProjectsRequest> {
  /**
   * pagination contains the pagination options for listing organizations
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListProjectsRequest.Filter filter = 2;
   */
  filter?: ListProjectsRequest_Filter;

  constructor(data?: PartialMessage<ListProjectsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListProjectsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "filter", kind: "message", T: ListProjectsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListProjectsRequest {
    return new ListProjectsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListProjectsRequest {
    return new ListProjectsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListProjectsRequest {
    return new ListProjectsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListProjectsRequest | PlainMessage<ListProjectsRequest> | undefined, b: ListProjectsRequest | PlainMessage<ListProjectsRequest> | undefined): boolean {
    return proto3.util.equals(ListProjectsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListProjectsRequest.Filter
 */
export class ListProjectsRequest_Filter extends Message<ListProjectsRequest_Filter> {
  /**
   * project_ids filters the response to only projects with these IDs
   *
   * @generated from field: repeated string project_ids = 1;
   */
  projectIds: string[] = [];

  /**
   * search performs case-insensitive search across project name, project ID, and repository name
   *
   * @generated from field: string search = 2;
   */
  search = "";

  /**
   * runner_ids filters the response to only projects that use environment classes from these runners
   *
   * @generated from field: repeated string runner_ids = 3;
   */
  runnerIds: string[] = [];

  /**
   * runner_kinds filters the response to only projects that use environment classes from runners of these kinds
   *
   * @generated from field: repeated gitpod.v1.RunnerKind runner_kinds = 4;
   */
  runnerKinds: RunnerKind[] = [];

  constructor(data?: PartialMessage<ListProjectsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListProjectsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "runner_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "runner_kinds", kind: "enum", T: proto3.getEnumType(RunnerKind), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListProjectsRequest_Filter {
    return new ListProjectsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListProjectsRequest_Filter {
    return new ListProjectsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListProjectsRequest_Filter {
    return new ListProjectsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListProjectsRequest_Filter | PlainMessage<ListProjectsRequest_Filter> | undefined, b: ListProjectsRequest_Filter | PlainMessage<ListProjectsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListProjectsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListProjectsResponse
 */
export class ListProjectsResponse extends Message<ListProjectsResponse> {
  /**
   * pagination contains the pagination options for listing organizations
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.Project projects = 2;
   */
  projects: Project[] = [];

  constructor(data?: PartialMessage<ListProjectsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListProjectsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "projects", kind: "message", T: Project, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListProjectsResponse {
    return new ListProjectsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListProjectsResponse {
    return new ListProjectsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListProjectsResponse {
    return new ListProjectsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListProjectsResponse | PlainMessage<ListProjectsResponse> | undefined, b: ListProjectsResponse | PlainMessage<ListProjectsResponse> | undefined): boolean {
    return proto3.util.equals(ListProjectsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteProjectRequest
 */
export class DeleteProjectRequest extends Message<DeleteProjectRequest> {
  /**
   * project_id specifies the project identifier
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  constructor(data?: PartialMessage<DeleteProjectRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteProjectRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteProjectRequest {
    return new DeleteProjectRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteProjectRequest {
    return new DeleteProjectRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteProjectRequest {
    return new DeleteProjectRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteProjectRequest | PlainMessage<DeleteProjectRequest> | undefined, b: DeleteProjectRequest | PlainMessage<DeleteProjectRequest> | undefined): boolean {
    return proto3.util.equals(DeleteProjectRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteProjectResponse
 */
export class DeleteProjectResponse extends Message<DeleteProjectResponse> {
  constructor(data?: PartialMessage<DeleteProjectResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteProjectResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteProjectResponse {
    return new DeleteProjectResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteProjectResponse {
    return new DeleteProjectResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteProjectResponse {
    return new DeleteProjectResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteProjectResponse | PlainMessage<DeleteProjectResponse> | undefined, b: DeleteProjectResponse | PlainMessage<DeleteProjectResponse> | undefined): boolean {
    return proto3.util.equals(DeleteProjectResponse, a, b);
  }
}

/**
 * ListProjectPoliciesRequest lists policies for a project.
 *
 * @generated from message gitpod.v1.ListProjectPoliciesRequest
 */
export class ListProjectPoliciesRequest extends Message<ListProjectPoliciesRequest> {
  /**
   * pagination contains the pagination options for listing project policies
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * project_id specifies the project identifier
   *
   * @generated from field: string project_id = 2;
   */
  projectId = "";

  constructor(data?: PartialMessage<ListProjectPoliciesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListProjectPoliciesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListProjectPoliciesRequest {
    return new ListProjectPoliciesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListProjectPoliciesRequest {
    return new ListProjectPoliciesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListProjectPoliciesRequest {
    return new ListProjectPoliciesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListProjectPoliciesRequest | PlainMessage<ListProjectPoliciesRequest> | undefined, b: ListProjectPoliciesRequest | PlainMessage<ListProjectPoliciesRequest> | undefined): boolean {
    return proto3.util.equals(ListProjectPoliciesRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListProjectPoliciesResponse
 */
export class ListProjectPoliciesResponse extends Message<ListProjectPoliciesResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.ProjectPolicy policies = 2;
   */
  policies: ProjectPolicy[] = [];

  constructor(data?: PartialMessage<ListProjectPoliciesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListProjectPoliciesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "policies", kind: "message", T: ProjectPolicy, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListProjectPoliciesResponse {
    return new ListProjectPoliciesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListProjectPoliciesResponse {
    return new ListProjectPoliciesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListProjectPoliciesResponse {
    return new ListProjectPoliciesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListProjectPoliciesResponse | PlainMessage<ListProjectPoliciesResponse> | undefined, b: ListProjectPoliciesResponse | PlainMessage<ListProjectPoliciesResponse> | undefined): boolean {
    return proto3.util.equals(ListProjectPoliciesResponse, a, b);
  }
}

/**
 * CreateProjectPolicyRequest creates a Project Policy.
 *
 * @generated from message gitpod.v1.CreateProjectPolicyRequest
 */
export class CreateProjectPolicyRequest extends Message<CreateProjectPolicyRequest> {
  /**
   * project_id specifies the project identifier
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * group_id specifies the group_id identifier
   *
   * @generated from field: string group_id = 2;
   */
  groupId = "";

  /**
   * @generated from field: gitpod.v1.ProjectRole role = 3;
   */
  role = ProjectRole.UNSPECIFIED;

  constructor(data?: PartialMessage<CreateProjectPolicyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateProjectPolicyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "role", kind: "enum", T: proto3.getEnumType(ProjectRole) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateProjectPolicyRequest {
    return new CreateProjectPolicyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateProjectPolicyRequest {
    return new CreateProjectPolicyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateProjectPolicyRequest {
    return new CreateProjectPolicyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateProjectPolicyRequest | PlainMessage<CreateProjectPolicyRequest> | undefined, b: CreateProjectPolicyRequest | PlainMessage<CreateProjectPolicyRequest> | undefined): boolean {
    return proto3.util.equals(CreateProjectPolicyRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateProjectPolicyResponse
 */
export class CreateProjectPolicyResponse extends Message<CreateProjectPolicyResponse> {
  /**
   * @generated from field: gitpod.v1.ProjectPolicy policy = 1;
   */
  policy?: ProjectPolicy;

  constructor(data?: PartialMessage<CreateProjectPolicyResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateProjectPolicyResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "policy", kind: "message", T: ProjectPolicy },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateProjectPolicyResponse {
    return new CreateProjectPolicyResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateProjectPolicyResponse {
    return new CreateProjectPolicyResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateProjectPolicyResponse {
    return new CreateProjectPolicyResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateProjectPolicyResponse | PlainMessage<CreateProjectPolicyResponse> | undefined, b: CreateProjectPolicyResponse | PlainMessage<CreateProjectPolicyResponse> | undefined): boolean {
    return proto3.util.equals(CreateProjectPolicyResponse, a, b);
  }
}

/**
 * UpdateProjectPolicyRequest updates a Project Policy.
 *
 * @generated from message gitpod.v1.UpdateProjectPolicyRequest
 */
export class UpdateProjectPolicyRequest extends Message<UpdateProjectPolicyRequest> {
  /**
   * project_id specifies the project identifier
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * group_id specifies the group_id identifier
   *
   * @generated from field: string group_id = 2;
   */
  groupId = "";

  /**
   * @generated from field: gitpod.v1.ProjectRole role = 3;
   */
  role = ProjectRole.UNSPECIFIED;

  constructor(data?: PartialMessage<UpdateProjectPolicyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateProjectPolicyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "role", kind: "enum", T: proto3.getEnumType(ProjectRole) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProjectPolicyRequest {
    return new UpdateProjectPolicyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProjectPolicyRequest {
    return new UpdateProjectPolicyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProjectPolicyRequest {
    return new UpdateProjectPolicyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProjectPolicyRequest | PlainMessage<UpdateProjectPolicyRequest> | undefined, b: UpdateProjectPolicyRequest | PlainMessage<UpdateProjectPolicyRequest> | undefined): boolean {
    return proto3.util.equals(UpdateProjectPolicyRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateProjectPolicyResponse
 */
export class UpdateProjectPolicyResponse extends Message<UpdateProjectPolicyResponse> {
  /**
   * @generated from field: gitpod.v1.ProjectPolicy policy = 1;
   */
  policy?: ProjectPolicy;

  constructor(data?: PartialMessage<UpdateProjectPolicyResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateProjectPolicyResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "policy", kind: "message", T: ProjectPolicy },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProjectPolicyResponse {
    return new UpdateProjectPolicyResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProjectPolicyResponse {
    return new UpdateProjectPolicyResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProjectPolicyResponse {
    return new UpdateProjectPolicyResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProjectPolicyResponse | PlainMessage<UpdateProjectPolicyResponse> | undefined, b: UpdateProjectPolicyResponse | PlainMessage<UpdateProjectPolicyResponse> | undefined): boolean {
    return proto3.util.equals(UpdateProjectPolicyResponse, a, b);
  }
}

/**
 * DeleteProjectPolicyRequest deletes a Project Policy.
 *
 * @generated from message gitpod.v1.DeleteProjectPolicyRequest
 */
export class DeleteProjectPolicyRequest extends Message<DeleteProjectPolicyRequest> {
  /**
   * project_id specifies the project identifier
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * group_id specifies the group_id identifier
   *
   * @generated from field: string group_id = 2;
   */
  groupId = "";

  constructor(data?: PartialMessage<DeleteProjectPolicyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteProjectPolicyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteProjectPolicyRequest {
    return new DeleteProjectPolicyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteProjectPolicyRequest {
    return new DeleteProjectPolicyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteProjectPolicyRequest {
    return new DeleteProjectPolicyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteProjectPolicyRequest | PlainMessage<DeleteProjectPolicyRequest> | undefined, b: DeleteProjectPolicyRequest | PlainMessage<DeleteProjectPolicyRequest> | undefined): boolean {
    return proto3.util.equals(DeleteProjectPolicyRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteProjectPolicyResponse
 */
export class DeleteProjectPolicyResponse extends Message<DeleteProjectPolicyResponse> {
  constructor(data?: PartialMessage<DeleteProjectPolicyResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteProjectPolicyResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteProjectPolicyResponse {
    return new DeleteProjectPolicyResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteProjectPolicyResponse {
    return new DeleteProjectPolicyResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteProjectPolicyResponse {
    return new DeleteProjectPolicyResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteProjectPolicyResponse | PlainMessage<DeleteProjectPolicyResponse> | undefined, b: DeleteProjectPolicyResponse | PlainMessage<DeleteProjectPolicyResponse> | undefined): boolean {
    return proto3.util.equals(DeleteProjectPolicyResponse, a, b);
  }
}

/**
 * ListProjectEnvironmentClassesRequest lists environment classes of a project.
 *
 * @generated from message gitpod.v1.ListProjectEnvironmentClassesRequest
 */
export class ListProjectEnvironmentClassesRequest extends Message<ListProjectEnvironmentClassesRequest> {
  /**
   * pagination contains the pagination options for listing project policies
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * project_id specifies the project identifier
   *
   * @generated from field: string project_id = 2;
   */
  projectId = "";

  constructor(data?: PartialMessage<ListProjectEnvironmentClassesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListProjectEnvironmentClassesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListProjectEnvironmentClassesRequest {
    return new ListProjectEnvironmentClassesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListProjectEnvironmentClassesRequest {
    return new ListProjectEnvironmentClassesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListProjectEnvironmentClassesRequest {
    return new ListProjectEnvironmentClassesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListProjectEnvironmentClassesRequest | PlainMessage<ListProjectEnvironmentClassesRequest> | undefined, b: ListProjectEnvironmentClassesRequest | PlainMessage<ListProjectEnvironmentClassesRequest> | undefined): boolean {
    return proto3.util.equals(ListProjectEnvironmentClassesRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListProjectEnvironmentClassesResponse
 */
export class ListProjectEnvironmentClassesResponse extends Message<ListProjectEnvironmentClassesResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.ProjectEnvironmentClass project_environment_classes = 2;
   */
  projectEnvironmentClasses: ProjectEnvironmentClass[] = [];

  constructor(data?: PartialMessage<ListProjectEnvironmentClassesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListProjectEnvironmentClassesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "project_environment_classes", kind: "message", T: ProjectEnvironmentClass, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListProjectEnvironmentClassesResponse {
    return new ListProjectEnvironmentClassesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListProjectEnvironmentClassesResponse {
    return new ListProjectEnvironmentClassesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListProjectEnvironmentClassesResponse {
    return new ListProjectEnvironmentClassesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListProjectEnvironmentClassesResponse | PlainMessage<ListProjectEnvironmentClassesResponse> | undefined, b: ListProjectEnvironmentClassesResponse | PlainMessage<ListProjectEnvironmentClassesResponse> | undefined): boolean {
    return proto3.util.equals(ListProjectEnvironmentClassesResponse, a, b);
  }
}

/**
 * UpdateProjectEnvironmentClassesRequest updates all project environment classes of a project.
 *
 * @generated from message gitpod.v1.UpdateProjectEnvironmentClassesRequest
 */
export class UpdateProjectEnvironmentClassesRequest extends Message<UpdateProjectEnvironmentClassesRequest> {
  /**
   * project_id specifies the project identifier
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * @generated from field: repeated gitpod.v1.ProjectEnvironmentClass project_environment_classes = 2;
   */
  projectEnvironmentClasses: ProjectEnvironmentClass[] = [];

  constructor(data?: PartialMessage<UpdateProjectEnvironmentClassesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateProjectEnvironmentClassesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "project_environment_classes", kind: "message", T: ProjectEnvironmentClass, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProjectEnvironmentClassesRequest {
    return new UpdateProjectEnvironmentClassesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProjectEnvironmentClassesRequest {
    return new UpdateProjectEnvironmentClassesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProjectEnvironmentClassesRequest {
    return new UpdateProjectEnvironmentClassesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProjectEnvironmentClassesRequest | PlainMessage<UpdateProjectEnvironmentClassesRequest> | undefined, b: UpdateProjectEnvironmentClassesRequest | PlainMessage<UpdateProjectEnvironmentClassesRequest> | undefined): boolean {
    return proto3.util.equals(UpdateProjectEnvironmentClassesRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateProjectEnvironmentClassesResponse
 */
export class UpdateProjectEnvironmentClassesResponse extends Message<UpdateProjectEnvironmentClassesResponse> {
  constructor(data?: PartialMessage<UpdateProjectEnvironmentClassesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateProjectEnvironmentClassesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProjectEnvironmentClassesResponse {
    return new UpdateProjectEnvironmentClassesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProjectEnvironmentClassesResponse {
    return new UpdateProjectEnvironmentClassesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProjectEnvironmentClassesResponse {
    return new UpdateProjectEnvironmentClassesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProjectEnvironmentClassesResponse | PlainMessage<UpdateProjectEnvironmentClassesResponse> | undefined, b: UpdateProjectEnvironmentClassesResponse | PlainMessage<UpdateProjectEnvironmentClassesResponse> | undefined): boolean {
    return proto3.util.equals(UpdateProjectEnvironmentClassesResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.Project
 */
export class Project extends Message<Project> {
  /**
   * id is the unique identifier for the project
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: gitpod.v1.ProjectMetadata metadata = 2;
   */
  metadata?: ProjectMetadata;

  /**
   * initializer is the content initializer
   *
   * @generated from field: gitpod.v1.EnvironmentInitializer initializer = 3;
   */
  initializer?: EnvironmentInitializer;

  /**
   * Use `environment_classes` instead.
   *
   * @generated from field: gitpod.v1.ProjectEnvironmentClass environment_class = 4 [deprecated = true];
   * @deprecated
   */
  environmentClass?: ProjectEnvironmentClass;

  /**
   * devcontainer_file_path is the path to the devcontainer file relative to the repo root
   *
   * @generated from field: string devcontainer_file_path = 5;
   */
  devcontainerFilePath = "";

  /**
   * environment_classes is the list of environment classes for the project
   *
   * @generated from field: repeated gitpod.v1.ProjectEnvironmentClass environment_classes = 11;
   */
  environmentClasses: ProjectEnvironmentClass[] = [];

  /**
   * @generated from field: gitpod.v1.Project.UsedBy used_by = 6;
   */
  usedBy?: Project_UsedBy;

  /**
   * automations_file_path is the path to the automations file relative to the repo root
   *
   * @generated from field: string automations_file_path = 7;
   */
  automationsFilePath = "";

  /**
   * technical_description is a detailed technical description of the project
   * This field is not returned by default in GetProject or ListProjects responses
   *
   * @generated from field: string technical_description = 8;
   */
  technicalDescription = "";

  /**
   * prebuild_configuration defines how prebuilds are created for this project.
   *
   * @generated from field: gitpod.v1.ProjectPrebuildConfiguration prebuild_configuration = 9;
   */
  prebuildConfiguration?: ProjectPrebuildConfiguration;

  /**
   * desired_phase is the desired phase of the project
   * When set to DELETED, the project is pending deletion
   *
   * @generated from field: gitpod.v1.ProjectPhase desired_phase = 10;
   */
  desiredPhase = ProjectPhase.UNSPECIFIED;

  /**
   * recommended_editors specifies the editors recommended for this project.
   *
   * @generated from field: gitpod.v1.RecommendedEditors recommended_editors = 12;
   */
  recommendedEditors?: RecommendedEditors;

  constructor(data?: PartialMessage<Project>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Project";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: ProjectMetadata },
    { no: 3, name: "initializer", kind: "message", T: EnvironmentInitializer },
    { no: 4, name: "environment_class", kind: "message", T: ProjectEnvironmentClass },
    { no: 5, name: "devcontainer_file_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "environment_classes", kind: "message", T: ProjectEnvironmentClass, repeated: true },
    { no: 6, name: "used_by", kind: "message", T: Project_UsedBy },
    { no: 7, name: "automations_file_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "technical_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "prebuild_configuration", kind: "message", T: ProjectPrebuildConfiguration },
    { no: 10, name: "desired_phase", kind: "enum", T: proto3.getEnumType(ProjectPhase) },
    { no: 12, name: "recommended_editors", kind: "message", T: RecommendedEditors },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Project {
    return new Project().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Project {
    return new Project().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Project {
    return new Project().fromJsonString(jsonString, options);
  }

  static equals(a: Project | PlainMessage<Project> | undefined, b: Project | PlainMessage<Project> | undefined): boolean {
    return proto3.util.equals(Project, a, b);
  }
}

/**
 * @generated from message gitpod.v1.Project.UsedBy
 */
export class Project_UsedBy extends Message<Project_UsedBy> {
  /**
   * Subjects are the 10 most recent subjects who have used the project to create an environment
   *
   * @generated from field: repeated gitpod.v1.Subject subjects = 4;
   */
  subjects: Subject[] = [];

  /**
   * Total number of unique subjects who have used the project
   *
   * @generated from field: int32 total_subjects = 3;
   */
  totalSubjects = 0;

  constructor(data?: PartialMessage<Project_UsedBy>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Project.UsedBy";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 4, name: "subjects", kind: "message", T: Subject, repeated: true },
    { no: 3, name: "total_subjects", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Project_UsedBy {
    return new Project_UsedBy().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Project_UsedBy {
    return new Project_UsedBy().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Project_UsedBy {
    return new Project_UsedBy().fromJsonString(jsonString, options);
  }

  static equals(a: Project_UsedBy | PlainMessage<Project_UsedBy> | undefined, b: Project_UsedBy | PlainMessage<Project_UsedBy> | undefined): boolean {
    return proto3.util.equals(Project_UsedBy, a, b);
  }
}

/**
 * RecommendedEditors contains the map of recommended editors and their versions.
 *
 * @generated from message gitpod.v1.RecommendedEditors
 */
export class RecommendedEditors extends Message<RecommendedEditors> {
  /**
   * editors maps editor aliases to their recommended versions.
   * Key is the editor alias (e.g., "intellij", "goland", "vscode").
   * Value contains the list of recommended versions for that editor.
   * If versions list is empty, all available versions are recommended.
   * Example: {"intellij": {versions: ["2025.1", "2024.3"]}, "goland": {}}
   *
   * @generated from field: map<string, gitpod.v1.EditorVersions> editors = 1;
   */
  editors: { [key: string]: EditorVersions } = {};

  constructor(data?: PartialMessage<RecommendedEditors>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RecommendedEditors";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "editors", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: EditorVersions} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RecommendedEditors {
    return new RecommendedEditors().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RecommendedEditors {
    return new RecommendedEditors().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RecommendedEditors {
    return new RecommendedEditors().fromJsonString(jsonString, options);
  }

  static equals(a: RecommendedEditors | PlainMessage<RecommendedEditors> | undefined, b: RecommendedEditors | PlainMessage<RecommendedEditors> | undefined): boolean {
    return proto3.util.equals(RecommendedEditors, a, b);
  }
}

/**
 * EditorVersions contains the recommended versions for an editor.
 *
 * @generated from message gitpod.v1.EditorVersions
 */
export class EditorVersions extends Message<EditorVersions> {
  /**
   * versions is the list of recommended versions for this editor.
   * If empty, all available versions are recommended.
   * Examples for JetBrains: ["2025.1", "2024.3"]
   *
   * @generated from field: repeated string versions = 1;
   */
  versions: string[] = [];

  constructor(data?: PartialMessage<EditorVersions>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.EditorVersions";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "versions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EditorVersions {
    return new EditorVersions().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EditorVersions {
    return new EditorVersions().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EditorVersions {
    return new EditorVersions().fromJsonString(jsonString, options);
  }

  static equals(a: EditorVersions | PlainMessage<EditorVersions> | undefined, b: EditorVersions | PlainMessage<EditorVersions> | undefined): boolean {
    return proto3.util.equals(EditorVersions, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ProjectEnvironmentClass
 */
export class ProjectEnvironmentClass extends Message<ProjectEnvironmentClass> {
  /**
   * @generated from oneof gitpod.v1.ProjectEnvironmentClass.environment_class
   */
  environmentClass: {
    /**
     * Use a local runner for the user
     *
     * @generated from field: bool local_runner = 1;
     */
    value: boolean;
    case: "localRunner";
  } | {
    /**
     * Use a fixed environment class on a given Runner. This cannot be a local runner's environment class.
     *
     * @generated from field: string environment_class_id = 2;
     */
    value: string;
    case: "environmentClassId";
  } | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * order is the priority of this entry
   *
   * @generated from field: int32 order = 3;
   */
  order = 0;

  constructor(data?: PartialMessage<ProjectEnvironmentClass>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ProjectEnvironmentClass";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "local_runner", kind: "scalar", T: 8 /* ScalarType.BOOL */, oneof: "environment_class" },
    { no: 2, name: "environment_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "environment_class" },
    { no: 3, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProjectEnvironmentClass {
    return new ProjectEnvironmentClass().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProjectEnvironmentClass {
    return new ProjectEnvironmentClass().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProjectEnvironmentClass {
    return new ProjectEnvironmentClass().fromJsonString(jsonString, options);
  }

  static equals(a: ProjectEnvironmentClass | PlainMessage<ProjectEnvironmentClass> | undefined, b: ProjectEnvironmentClass | PlainMessage<ProjectEnvironmentClass> | undefined): boolean {
    return proto3.util.equals(ProjectEnvironmentClass, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ProjectMetadata
 */
export class ProjectMetadata extends Message<ProjectMetadata> {
  /**
   * organization_id is the ID of the organization that contains the environment
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * name is the human readable name of the project
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * creator is the identity of the project creator
   *
   * @generated from field: gitpod.v1.Subject creator = 3;
   */
  creator?: Subject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;

  constructor(data?: PartialMessage<ProjectMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ProjectMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "creator", kind: "message", T: Subject },
    { no: 4, name: "created_at", kind: "message", T: Timestamp },
    { no: 5, name: "updated_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProjectMetadata {
    return new ProjectMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProjectMetadata {
    return new ProjectMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProjectMetadata {
    return new ProjectMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: ProjectMetadata | PlainMessage<ProjectMetadata> | undefined, b: ProjectMetadata | PlainMessage<ProjectMetadata> | undefined): boolean {
    return proto3.util.equals(ProjectMetadata, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ProjectPolicy
 */
export class ProjectPolicy extends Message<ProjectPolicy> {
  /**
   * @generated from field: string group_id = 1;
   */
  groupId = "";

  /**
   * role is the role assigned to the group
   *
   * @generated from field: gitpod.v1.ProjectRole role = 2;
   */
  role = ProjectRole.UNSPECIFIED;

  constructor(data?: PartialMessage<ProjectPolicy>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ProjectPolicy";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "role", kind: "enum", T: proto3.getEnumType(ProjectRole) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProjectPolicy {
    return new ProjectPolicy().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProjectPolicy {
    return new ProjectPolicy().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProjectPolicy {
    return new ProjectPolicy().fromJsonString(jsonString, options);
  }

  static equals(a: ProjectPolicy | PlainMessage<ProjectPolicy> | undefined, b: ProjectPolicy | PlainMessage<ProjectPolicy> | undefined): boolean {
    return proto3.util.equals(ProjectPolicy, a, b);
  }
}

/**
 * ProjectPrebuildConfiguration defines how prebuilds are created for a project.
 * Prebuilds create environment snapshots that enable faster environment startup times.
 *
 * @generated from message gitpod.v1.ProjectPrebuildConfiguration
 */
export class ProjectPrebuildConfiguration extends Message<ProjectPrebuildConfiguration> {
  /**
   * enabled controls whether prebuilds are created for this project.
   * When disabled, no automatic prebuilds will be triggered.
   *
   * @generated from field: bool enabled = 1;
   */
  enabled = false;

  /**
   * environment_class_ids specifies which environment classes should have prebuilds created.
   * If empty, no prebuilds are created.
   *
   * @generated from field: repeated string environment_class_ids = 2;
   */
  environmentClassIds: string[] = [];

  /**
   * timeout is the maximum duration allowed for a prebuild to complete.
   * If not specified, defaults to 1 hour.
   * Must be between 5 minutes and 2 hours.
   *
   * @generated from field: google.protobuf.Duration timeout = 3;
   */
  timeout?: Duration;

  /**
   * trigger defines when prebuilds should be created.
   *
   * @generated from field: gitpod.v1.PrebuildTrigger trigger = 4;
   */
  trigger?: PrebuildTrigger;

  /**
   * executor specifies who runs prebuilds for this project.
   * The executor's SCM credentials are used to clone the repository.
   * If not set, defaults to the project creator.
   *
   * @generated from field: gitpod.v1.Subject executor = 5;
   */
  executor?: Subject;

  /**
   * enable_jetbrains_warmup controls whether JetBrains IDE warmup runs during prebuilds.
   *
   * @generated from field: bool enable_jetbrains_warmup = 6;
   */
  enableJetbrainsWarmup = false;

  constructor(data?: PartialMessage<ProjectPrebuildConfiguration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ProjectPrebuildConfiguration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "environment_class_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "timeout", kind: "message", T: Duration },
    { no: 4, name: "trigger", kind: "message", T: PrebuildTrigger },
    { no: 5, name: "executor", kind: "message", T: Subject },
    { no: 6, name: "enable_jetbrains_warmup", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProjectPrebuildConfiguration {
    return new ProjectPrebuildConfiguration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProjectPrebuildConfiguration {
    return new ProjectPrebuildConfiguration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProjectPrebuildConfiguration {
    return new ProjectPrebuildConfiguration().fromJsonString(jsonString, options);
  }

  static equals(a: ProjectPrebuildConfiguration | PlainMessage<ProjectPrebuildConfiguration> | undefined, b: ProjectPrebuildConfiguration | PlainMessage<ProjectPrebuildConfiguration> | undefined): boolean {
    return proto3.util.equals(ProjectPrebuildConfiguration, a, b);
  }
}

/**
 * PrebuildTrigger defines when prebuilds should be created for a project.
 *
 * @generated from message gitpod.v1.PrebuildTrigger
 */
export class PrebuildTrigger extends Message<PrebuildTrigger> {
  /**
   * @generated from oneof gitpod.v1.PrebuildTrigger.trigger
   */
  trigger: {
    /**
     * daily_schedule triggers a prebuild once per day at the specified hour (UTC).
     * The actual start time may vary slightly to distribute system load.
     *
     * @generated from field: gitpod.v1.PrebuildTrigger.DailySchedule daily_schedule = 1;
     */
    value: PrebuildTrigger_DailySchedule;
    case: "dailySchedule";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<PrebuildTrigger>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.PrebuildTrigger";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "daily_schedule", kind: "message", T: PrebuildTrigger_DailySchedule, oneof: "trigger" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PrebuildTrigger {
    return new PrebuildTrigger().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PrebuildTrigger {
    return new PrebuildTrigger().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PrebuildTrigger {
    return new PrebuildTrigger().fromJsonString(jsonString, options);
  }

  static equals(a: PrebuildTrigger | PlainMessage<PrebuildTrigger> | undefined, b: PrebuildTrigger | PlainMessage<PrebuildTrigger> | undefined): boolean {
    return proto3.util.equals(PrebuildTrigger, a, b);
  }
}

/**
 * DailySchedule triggers prebuilds once per day at a specified hour.
 *
 * @generated from message gitpod.v1.PrebuildTrigger.DailySchedule
 */
export class PrebuildTrigger_DailySchedule extends Message<PrebuildTrigger_DailySchedule> {
  /**
   * hour_utc is the hour of day (0-23) in UTC when the prebuild should start.
   * The actual start time may be adjusted by a few minutes to balance system load.
   *
   * @generated from field: int32 hour_utc = 1;
   */
  hourUtc = 0;

  constructor(data?: PartialMessage<PrebuildTrigger_DailySchedule>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.PrebuildTrigger.DailySchedule";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "hour_utc", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PrebuildTrigger_DailySchedule {
    return new PrebuildTrigger_DailySchedule().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PrebuildTrigger_DailySchedule {
    return new PrebuildTrigger_DailySchedule().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PrebuildTrigger_DailySchedule {
    return new PrebuildTrigger_DailySchedule().fromJsonString(jsonString, options);
  }

  static equals(a: PrebuildTrigger_DailySchedule | PlainMessage<PrebuildTrigger_DailySchedule> | undefined, b: PrebuildTrigger_DailySchedule | PlainMessage<PrebuildTrigger_DailySchedule> | undefined): boolean {
    return proto3.util.equals(PrebuildTrigger_DailySchedule, a, b);
  }
}

